import { render } from "./SearchDropdown.vue?vue&type=template&id=36d856a0&scoped=true&ts=true"
import script from "./SearchDropdown.vue?vue&type=script&lang=ts"
export * from "./SearchDropdown.vue?vue&type=script&lang=ts"

import "./SearchDropdown.vue?vue&type=style&index=0&id=36d856a0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d856a0"]])

export default __exports__